module.exports = __webpack_public_path__ + "static/media/sg12sj.c6764456.png";